module.exports = __webpack_public_path__ + "6b2a928e27a53aaecd996c2061f7a37c.pdf";